import * as React from 'react';

import * as styles from './RubricItem.css';

interface IRubricItemProps {
  href: string;
  onClick?(): void;
}

export const RubricItem: React.FC<IRubricItemProps> = ({ href, children, onClick }) => {
  return (
    <li className={styles['container']}>
      <a href={href} onClick={onClick}>
        {children}
      </a>
    </li>
  );
};
